import { useGetFeatureToggleVariantsForKeys } from '@seek/hirer-feature-toggle';
import { useMemo } from 'react';

import type { Experiment } from 'src/App/config/experiments';

interface TrackingExperiment {
  num: number;
  id: string;
  variant: any;
}

export const useTrackingExperiments = (
  experiments: Experiment[],
): TrackingExperiment[] => {
  const experimentIds = experiments.map((exp) => exp.experimentId);
  const featureToggleVariants: Record<string, any> =
    useGetFeatureToggleVariantsForKeys(experimentIds);

  const trackingExperiments: TrackingExperiment[] = useMemo(
    () =>
      experiments.map((experiment) => ({
        num: experiment.experimentNum,
        id: experiment.experimentId,
        variant: featureToggleVariants[experiment.experimentId],
      })),
    [experiments, featureToggleVariants],
  );

  return trackingExperiments;
};
